import { cn } from "@roman/shared/utils";

const Skeleton: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => {
  return <div className={cn("animate-pulse rounded-md bg-primary/10", className)} {...props} />;
};

export { Skeleton };
